module.exports = __webpack_public_path__ + "static/media/pastafarianism.11fb8f74.svg";